import React, { type ReactElement } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { TextField } from '@elevator/ui';
import type { TextFieldProps } from '@mui/material/TextField';
import { getCountryOptions } from 'lib/countries';

const countryOptions = getCountryOptions();

export type CountrySelectProps = Pick<
  TextFieldProps,
  | 'id'
  | 'name'
  | 'label'
  | 'value'
  | 'onChange'
  | 'onBlur'
  | 'error'
  | 'helperText'
  | 'required'
  | 'fullWidth'
>;

/**
 * ISO 3166-1 alpha-2 country selector for billing forms.
 * Values are two-letter codes (e.g. US, CA); labels use the shorter of official/alias English names.
 */
const CountrySelect = ({
  id = 'country',
  name = 'country',
  label = 'Country',
  value,
  onChange,
  onBlur,
  error,
  helperText,
  required = false,
  fullWidth = true,
}: CountrySelectProps): ReactElement => {
  return (
    <TextField
      id={id}
      name={name}
      label={label}
      select
      required={required}
      fullWidth={fullWidth}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      helperText={helperText}
      autoComplete="country"
      data-component="CountrySelect"
      slotProps={{
        select: {
          MenuProps: {
            PaperProps: {
              sx: { maxHeight: 320 },
            },
          },
        },
      }}
    >
      {countryOptions.map(({ code, name: countryName }) => (
        <MenuItem key={code} value={code}>
          {countryName}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default CountrySelect;
